import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_CREDIT_CHARGE_VESSEL_COL_DEF, transferRowData } from "presentation/constant/CreditNote/CreditNoteVesselColumnDefinition";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useCreditNoteDetailVesselVM } from "presentation/hook/CreditNote/useCreditNoteDetailVesselVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const CreditNoteVesselTablePanel = () => {
    const [creditNoteDetailState] = useCreditNoteDetailTracked();
    const creditNoteDetailVesselVM = useCreditNoteDetailVesselVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;
    const { selectedCreditNoteDetailVesselRow } = creditNoteDetailState;
    const gridRef: any = useRef();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();
    const tableId = 'credit-note-dtl-cntr-records-table';

    const handleApply = useCallback(async () => {
        if (selectedCreditNoteDetailVesselRow.length === 0) {
            messageBarVM.showError('Please select a record.');
            return;
        }

        setIsLoading(true);
        creditNoteDetailVesselVM.apply(selectedCreditNoteDetailVesselRow).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, [selectedCreditNoteDetailVesselRow, messageBarVM, creditNoteDetailVesselVM]);

    const isDisableApply = () => {
        return selectedCreditNoteDetailVesselRow.length === 0;
    }

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        creditNoteDetailVesselVM.updateSelectedCreditNoteDetails(selectedRows);
    }, [creditNoteDetailVesselVM])

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        if (!onTableSelectionClicked) {
            gridRef.current?.gridRef.current.api?.deselectAll();
        }

    })

    const memoCreditNoteDetailVesselTable = useMemo(() => {
        return <NbisTable
            id={tableId}
            isNewColumnSetting={true}
            columns={INITIAL_CREDIT_CHARGE_VESSEL_COL_DEF?.slice()}
            data={transferRowData(creditNoteDetailState.creditNoteDetailVessels)}
            showPaginator={false}
            editable={false}
            showAddIcon={false}
            showDeleteButton={false}
            showReloadIcon={false}
            isScrollHighlighted={true}
            isRowHighligted={true}
            selectionMode={false}
            handleSelectionChanged={handleSelectionChange}
            gridHeight="customHeight"
            customHeight="calc(57vh)"
            ref={gridRef}
        />
    }, [creditNoteDetailState.creditNoteDetailVessels, handleSelectionChange])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>{<TableWrapper>{memoCreditNoteDetailVesselTable}
        {<StyledAction className="tm-animated-wrapper">
            {(allowUpdate) && <HPHButton disabled={isDisableApply()} label={WorkspaceConstant.Common.BUTTON_UPDATE} size={'Small'} theme={'Primary'} onClick={handleApply} />}
        </StyledAction>}
    </TableWrapper>}</>;
}

export default memo(CreditNoteVesselTablePanel);